{
  "durationSelector": {
    "title": "Kies uw {0}",
    "titleWithoutDiscounts": "Kies uw looptijd",
    "singleDurationTitle": "Uw kortingsperiode",
    "disclaimer": {
      "default": "Na deze periode kunt u maandelijks opzeggen.",
      "afterDuration": "Na {0} {1} kunt u maandelijks opzeggen.",
      "cancel": "U kunt uw bestelling binnen 14 dagen annuleren."
    }
  }
}